import api from './api';

export const getPaymentsByCustomerApi = customerId => {
  return api.get(`/payment/customer/${customerId}`);
};

export const addPaymentApi = params => {
  return api.post('/payment', params);
};

export const getAllPaymentsApi = params => {
  return api.get('/payment', {params});
};

export const getTotlaPaymentsApi = params => {
  return api.get('/payment/total', {params});
};

export const getPaymentsGraphApi = () => {
  return api.get('/payment/graph');
};

export const getPendingPaymentsApi = params => {
  return api.get('/customers/pending', {params});
};
